import { Theme } from '@mui/material/styles'
export const locationListStyles = {
  header: { fontSize: '16px' },

  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: (theme: Theme) => theme.spacing(1.5),
  },

  pagination: {
    marginTop: (theme: Theme) => theme.spacing(2),
    marginRight: (theme: Theme) => theme.spacing(0.8),
    float: 'right',
  },

  columns: {
    overflow: 'hidden auto',
    display: 'flex',
    margin: (theme: Theme) => theme.spacing(-1),
  },
}
